import axios from '@axios'

export const state = {
  portNames: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allPortNames: (state) => state.portNames,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_PORT_NAME: (state, resp) => {
    if (!resp) return null
    state.portNames = resp.portNames || (Array.isArray(resp) ? resp : [])
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  CREATE_PORT_NAME: (state, portName) => {
    state.portNames.push(portName)
  },
  UPDATE_PORT_NAME: (state, portName) => {
    const index = state.portNames.findIndex((p) => p.id === portName.id)
    if (index !== -1) state.portNames.splice(index, 1, portName)
  },
  DELETE_PORT_NAME: (state, portName) => {
    state.portNames = state.portNames.filter((w) => w.id !== portName.id)
  },
}

export const actions = {
  async getPortNames({ commit }, params = {}) {
    await axios
      .get('/api/port-names', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_PORT_NAME', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_PORT_NAME',
          err.response.status === 404 ? { portNames: [] } : null
        )
      })
  },
  async createPortName({ commit }, portName) {
    return axios.post(`/api/port-names`, portName)
  },
  async editPortName({ commit }, portName) {
    return axios.put(`/api/port-names`, portName)
  },
  async deletePortName({ commit }, portName) {
    await axios.delete(`/api/port-names/${portName.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_PORT_NAME', portName)
      }
    })
  },
}
